export const FETCH_MONTHLY_REPORTS_REQUEST = 'FETCH_MONTHLY_REPORTS_REQUEST';
export const FETCH_MONTHLY_REPORTS_SUCCESS = 'FETCH_MONTHLY_REPORTS_SUCCESS';
export const FETCH_MONTHLY_REPORTS_FAILURE = 'FETCH_MONTHLY_REPORTS_FAILURE';
export const RESET_MONTHLY_REPORTS = 'RESET_MONTHLY_REPORTS';
export const FETCH_ANNUAL_REPORTS_REQUEST = 'FETCH_ANNUAL_REPORTS_REQUEST';
export const FETCH_ANNUAL_REPORTS_SUCCESS = 'FETCH_ANNUAL_REPORTS_SUCCESS';
export const FETCH_ANNUAL_REPORTS_FAILURE = 'FETCH_ANNUAL_REPORTS_FAILURE';